module.exports = __webpack_public_path__ + "img/2.ae6826cf.jpg";